export const getMapModalOpen = ({ state }) =>
  state.mapModalReducer.isMapModalOpen;
export const getToastOpen = ({ state }) => state.mapModalReducer.isToastOpen;
